export const pizzas = [
  {
    img: '/img/cheese.png',
    title: 'Margarita',
    ingredients:
      'Baked pork ham, cranberry sauce, lingonberries, red onion, mozzarella, signature alfredo sauce',
    price: { small: 18, medium: 23, large: 25 },
  },
  {
    img: '/img/chiken-burger.png',
    title: 'Chicken-burger',
    ingredients:
      'Bacon, Chicken, Onion, Pickled cucumbers, Fresh tomatoes, Mozzarella cheese, Piquant sauce',
    price: { small: 17, medium: 22, large: 24 },
  },
  {
    img: '/img/4season.png',
    title: '4 Season',
    ingredients:
      'Bacon, Ham, Mushrooms, Chicken, Onions, Olives, Pickled Cucumbers, Hunting sausages, Pepperoni, Fresh tomatoes, BBQ sauce, Mozzarella cheese, Feta cheese, Tomato sauce',
    price: { small: 18, medium: 21, large: 23 },
  },
  {
    img: '/img/pepperoni.png',
    title: 'Pepperoni',
    ingredients: 'Pepperoni, Mozzarella Cheese, Tomato sauce',
    price: { small: 17, medium: 24, large: 25 },
  },
  {
    img: '/img/pizza-tuniza.png',
    title: 'Pizza-tuniza',
    ingredients:
      'Onion, Black Olives, Fresh Tomatoes, Mozzarella Cheese, Original Garlic Sauce, Tuna',
    price: { small: 19, medium: 26, large: 27 },
  },
  {
    img: '/img/chikenBBQ.png',
    title: 'Chiken BBQ',
    ingredients:
      'Mushrooms, Chicken, Onion, BBQ sauce, Mozzarella cheese, Tomato sauce',
    price: { small: 19, medium: 26, large: 27 },
  },
  {
    img: '/img/vedji-fresh.png',
    title: 'Vedzhi Fresh',
    ingredients:
      'Mushrooms, Olives, Fresh tomatoes, Mozzarella cheese, Feta cheese, Tomato sauce',
    price: { small: 18, medium: 21, large: 23 },
  },
  {
    img: '/img/gavay.png',
    title: 'Hawaiian',
    ingredients: 'Pineapple, Ham, Mozzarella cheese, Tomato sauce',
    price: { small: 18, medium: 21, large: 23 },
  },
  {
    img: '/img/carbonara.png',
    title: 'Carbonara',
    ingredients: 'Bacon, Fresh tomatoes, Carbonara sauce, Mozzarella cheese',
    price: { small: 17, medium: 22, large: 24 },
  },
  {
    img: '/img/dubl-peperoni.png',
    title: 'Dubl Pepperoni',
    ingredients: 'Pepperoni, Mozzarella Cheese, Tomato sauce',
    price: { small: 20, medium: 27, large: 28 },
  },
  {
    img: '/img/meat.png',
    title: 'Meat',
    ingredients:
      'Ham, Chicken, Hunting sausages, Pepperoni, Mozzarella cheese, Tomato sauce',
    price: { small: 17, medium: 22, large: 24 },
  },
  {
    img: '/img/margarita-gurme.png',
    title: 'Margarita Gurme',
    ingredients: 'Fresh tomatoes, Mozzarella cheese, Tomato sauce',
    price: { small: 17, medium: 22, large: 24 },
  },
];

export const drinks = [
  { img: '/img/drinks/col_zero.jpeg', title: 'Coca-Cola zero', price: 8 },
  { img: '/img/drinks/cola_light.jpeg', title: 'Coca-Cola light', price: 8 },
  { img: '/img/drinks/cola.jpeg', title: 'Coca-Cola', price: 8 },
  { img: '/img/drinks/cola.jpeg', title: 'Coca-Cola', price: 8 },
  { img: '/img/drinks/7up.jpeg', title: '7up', price: 8 },
  { img: '/img/drinks/7up.jpeg', title: '7up', price: 8 },
  { img: '/img/drinks/col_zero.jpeg', title: 'Coca-Cola zero', price: 8 },
  { img: '/img/drinks/cola_light.jpeg', title: 'Coca-Cola light', price: 8 },
];

export const desserts = [
  {
    img: '/img/desserts/RU.png',
    title: 'Curls with apricot',
    description:
      'Portion 8 pcs. Hot sweet apricot curls sprinkled with powdered sugar.',
    price: 5,
  },
  {
    img: '/img/desserts/RU1.png',
    title: 'Blackcurrant curls',
    description:
      'Portion 8 pcs. Sweet and tender blackcurrant curls sprinkled with powdered sugar.',
    price: 5,
  },
  {
    img: '/img/desserts/RU2.png',
    title: 'Dessert Chocolate lava',
    description:
      'Delicate crispy souffle stuffed with hot chocolate, sprinkled with a thin layer of sugar.',
    price: 8,
  },
  {
    img: '/img/desserts/RU3.png',
    title: 'Dessert Pistachio-raspberry',
    description:
      'Light, delicately airy dessert with pistachio-raspberry flavor. Portion - 90 grams.',
    price: 7,
  },
];

export const contacts = [
  { title: 'Support', contact: 'Tel (703) 256-0800' },
  { title: 'location', contact: '81 Pope Avenue,Hilton Head Island, SC 29928' },
  { title: 'Press service contacts', contact: 'press@reactpizza.com' },
  { title: 'For corporate orders', contact: 'b2b@reactpizza.com' },
  { title: 'for rent', contact: 'rent@reactpizza.com' },
  { title: 'purchasing department', contact: 'pr@reactpizza.com' },
];
